import NotFoundView from '@/components/error/404.vue'
import Agentmanagement from '@/components/view/Agentmanagement/main.vue'
import Account from '@/components/view/allbots/Account'
import SettingComponent from '@/components/view/billing/SettingComponent'
import Upgrade from '@/components/view/billing/Upgrade'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Chat from '@/components/view/chat/Chat'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'
import Dashboard from '@/components/view/dashboard/Dashboard'
import Export from '@/components/view/Export/Export'
import GetCurrentLocation from '@/components/view/GetCurrentLocation.vue'
import Setup from '@/components/view/getstarted/Setup'
import Comment from '@/components/view/intent/CommentToInbox'
import Conversation from '@/components/view/intent/Conversation'
import Training from '@/components/view/intent/Training/index'
import Live from '@/components/view/live/Main'
import LivechatView from '@/components/view/livechat/LivechatView'
import PBlog from '@/components/view/partner/Blog'
// import PCustomer from '@/components/view/partner/Customer'
import PProfile from '@/components/view/partner/Profile'
import PRedeemCode from '@/components/view/partner/RedeemCode'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'

import Template from '@/components/view/template/template'
import Ticket from '@/components/view/template/ticket/main.vue'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'
import TcpBroadcast from '@/components/view/template/tcp/Broadcast'
import TcpPluginBroadcast from '@/components/view/template/tcp/PluginBroadcast'
import Unauthorized from '@/components/view/Unauthorized'

import { store } from '@/store/store'
import Vue from 'vue'
import Router from 'vue-router'
import jsonwebtoken from 'jsonwebtoken'
import CheckInCheckOut from '@/components/view/CheckInCheckOut'
import AssetWiseExecutiveManagement from '@/components/view/template/AssetWise/ExecutiveManagement'
import AssetWiseManagement from '@/components/view/template/AssetWise/Management'
import AssetWiseBrokerManagement from '@/components/view/template/AssetWise/Management/Broker'
import AssetWiseLandSaleManagement from '@/components/view/template/AssetWise/Management/LandSale'
import AssetWiseExecutiveRecordManagement from '@/components/view/template/AssetWise/Management/ExecutiveRecord'
import AssetWiseBroadcast from '@/components/view/template/AssetWise/Broadcast'
import AssetWiseExecutiveBroadcast from '@/components/view/template/AssetWise/ExecutiveBroadcast'
import AssetWiseExecutiveBroadcastCreate from '@/components/view/template/AssetWise/ExecutiveBroadcastCreate'

import Login from '@/components/login/Login.vue'
import Nigol from '@/components/login/Nigol.vue'
import Chat2PayLogin from '@/components/login/Chat2Pay.vue'
import LineNotify from '@/components/view/linenotify/Linenotify.vue'
import ConnectLine from '@/components/login/ConnectLine.vue'
import PrepareLine from '@/components/view/linenotify/Prepare.vue'

import PageConfig from '@/components/view/AdvancedSetting/PageConfig.vue'
import WarroomConfig from '@/components/view/AdvancedSetting/WarroomConfig.vue'
import WhatsappTemplateManagment from '@/components/view/whatsapp/TemplateManagement'

import Ticket3Checkin from '@/components/view/ticket3/checkin/index.vue'
import Ticket3TicketList from '@/components/view/ticket3/ticket-management/TicketList.vue'
import Ticket3FunnelView from '@/components/view/ticket3/ticket-management/FunnelView.vue'
import Ticket3AgentView from '@/components/view/ticket3/ticket-management/AgentView.vue'
import Ticket3Setting from '@/components/view/ticket3/ticket-management/Setting/index.vue'
import Ticket3AgentOverview from '@/components/view/ticket3/agent-management/overview/index.vue'
import Ticket3AgentPerformance from '@/components/view/ticket3/agent-management/AgentPerformance.vue'
import Ticket3AgentPerformanceSummary from '@/components/view/ticket3/agent-management/agents/Summary/index.vue'
import Ticket3AgentPerformanceDetail from '@/components/view/ticket3/agent-management/agents/Performance/index.vue'
import Ticket3AgentManage from '@/components/view/ticket3/agent-management/AgentManage.vue'
import Ticket3Wrapup from '@/components/view/ticket3/ticket-management/WrapUp/index.vue'
import LayoutTicketManagement from '@/components/view/ticket3/ticket-management/LayoutTicketManagement.vue'
import LayoutAgentManagement from '@/components/view/ticket3/agent-management/LayoutAgentManagement.vue'

import LayoutSurvey from '@/components/view/survey/LayoutSurvey.vue'
import Survey from '@/components/view/survey/survey/index.vue'

import TigerpolyMember from '@/components/view/template/tigerpoly/member/Member.vue'
import TigerpolyReporting from '@/components/view/template/tigerpoly/reporting/Reporting.vue'

import SuperrichBranch from '@/components/view/template/superrich/branch/Branch.vue'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: LineNotify
      }
    ]
  },
  {
    path: '/connectline',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: ConnectLine
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: PrepareLine
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('th')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: Nigol
      },
      {
        path: 'login',
        name: 'login',
        component: Login
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: Chat2PayLogin,
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'allinonechat',
        name: 'allinonechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'All-in-one chat'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'getcurrentlocation',
        name: 'getcurrentlocation',
        component: GetCurrentLocation
      },
      {
        path: 'ticket',
        name: 'ticket',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: SettingComponent,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'setting',
        name: 'setting-component',
        component: SettingComponent,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        path: 'RedeemCode',
        name: 'RedeemCode',
        component: RedeemCode,
        beforeEnter: guardRoute,
        meta: {
          title: 'Redeem Code'
        }
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live'
        }
      },

      {
        path: 'agentmanagement',
        name: 'AgentManagement',
        component: Agentmanagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Agent management'
        }
      },

      {
        path: 'partner',
        component: {
          name: 'partner',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'profile'
          },
          {
            path: 'profile',
            name: 'profile',
            component: PProfile,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Profile'
            }
          },
          {
            path: 'blog',
            name: 'blog',
            component: PBlog,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Blog'
            }
          },
          {
            path: 'redeemcode',
            name: 'redeemcode',
            component: PRedeemCode,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Redeem Code'
            }
          }
          // {
          //   path: 'customer',
          //   name: 'customer',
          //   component: PCustomer,
          //   beforeEnter: guardPartnerRoute,
          //   meta: {
          //     title: 'Partner Customer'
          //   }
          // }
        ]
      },
      {
        path: 'export',
        name: 'export',
        component: Export,
        beforeEnter: guardRoute,
        meta: {
          title: 'Export'
        }
      },
      {
        path: 'plugin/unauthorized',
        name: 'export',
        component: Unauthorized,
        meta: {
          title: 'Unauthorized'
        }
      },
      {
        path: 'tcp',
        beforeEnter: guardRoute,
        component: {
          name: 'tcp',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: 'broadcast',
            name: 'tcp-broadcast',
            component: TcpBroadcast
          }
        ]
      },
      {
        path: 'tcp/plugin/broadcast',
        beforeEnter: guardRoutePageToken,
        name: 'broadcast',
        component: TcpPluginBroadcast
      },
      {
        path: 'advanced-setting',
        beforeEnter: guardRoute,
        component: {
          name: 'advanced-setting',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: 'page-config',
            name: 'page-config',
            component: PageConfig
          },
          {
            path: 'warroom-config',
            name: 'warroom-config',
            component: WarroomConfig
          }
        ]
      },
      {
        path: 'assetwise/executive-management',
        name: 'assetwise-executive-management',
        component: AssetWiseExecutiveManagement,
        beforeEnter: guardRoute,
        meta: {
          title: 'Executive Management'
        }
      },
      {
        path: 'assetwise/management',
        name: 'assetwise-management',
        component: AssetWiseManagement,
        beforeEnter: guardRoute,
        redirect: {
          name: 'assetwise-management-land-sales'
        },
        children: [
          {
            path: 'brokers',
            name: 'assetwise-management-brokers',
            component: AssetWiseBrokerManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Brokers'
            }
          },
          {
            path: 'land-sales',
            name: 'assetwise-management-land-sales',
            component: AssetWiseLandSaleManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Land Sales'
            }
          },
          {
            path: 'executive-records',
            name: 'assetwise-management-executive-records',
            component: AssetWiseExecutiveRecordManagement,
            beforeEnter: guardRoute,
            meta: {
              title: 'AssetWise Management: Executive Records'
            }
          }
        ]
      },
      {
        path: 'assetwise/broadcast',
        name: 'assetwise-broadcast',
        component: AssetWiseBroadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        },
        redirect: {
          name: 'assetwise-broadcast-main'
        },
        children: [
          {
            path: 'main',
            name: 'assetwise-broadcast-main',
            component: Broadcast,
            beforeEnter: guardRoute,
            props: {
              child: true
            }
          },
          {
            path: 'executive',
            name: 'assetwise-broadcast-executive',
            component: AssetWiseExecutiveBroadcast,
            beforeEnter: guardRoute
          },
          {
            path: 'executive/create',
            name: 'assetwise-broadcast-executive-create',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute
          },
          {
            path: 'executive/:id',
            name: 'assetwise-broadcast-executive-view',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute,
            props: {
              readonly: true
            }
          },
          {
            path: 'executive/:id/edit',
            name: 'assetwise-broadcast-executive-edit',
            component: AssetWiseExecutiveBroadcastCreate,
            beforeEnter: guardRoute,
            props: {
              edit: true
            }
          }
        ]
      },
      {
        path: 'whatsapp-template-management',
        name: 'WhatsappTemplateManagment',
        component: WhatsappTemplateManagment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Whatsapp Template Managment'
        }
      },
      {
        path: 'tcp',
        beforeEnter: guardRoute,
        component: {
          name: 'tcp',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: 'broadcast',
            name: 'tcp-broadcast',
            component: TcpBroadcast
          }
        ]
      },
      {
        path: 'ticket3',
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        },
        component: {
          name: 'ticket3',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'checkin'
          },
          {
            path: 'checkin',
            name: 'ticket3-checkin',
            component: Ticket3Checkin
          },
          {
            path: 'ticket-management',
            name: 'ticket3-management',
            component: LayoutTicketManagement,
            children: [
              {
                path: '',
                redirect: 'ticket'
              },
              {
                path: 'ticket',
                name: 'ticket3-ticket-list',
                component: Ticket3TicketList
              },
              {
                path: 'funnel',
                name: 'ticket3-funnel-view',
                component: Ticket3FunnelView
              },
              {
                path: 'agent',
                name: 'ticket3-agent-view',
                component: Ticket3AgentView
              },
              { path: 'wrapup', name: 'ticket3-wrapup', component: Ticket3Wrapup },
              {
                path: 'setting',
                name: 'ticket3-setting',
                component: Ticket3Setting
              }
            ]
          },
          {
            path: 'agent-management',
            name: 'ticket3-agent-management',
            component: LayoutAgentManagement,
            children: [
              {
                path: 'agent',
                name: 'ticket3-agent-overview',
                component: Ticket3AgentOverview
              },
              {
                path: 'performance',
                name: 'ticket3-agent-performance',
                component: Ticket3AgentPerformance,
                children: [
                  {
                    path: 'summary',
                    name: 'ticket3-agent-performance-summary',
                    component: Ticket3AgentPerformanceSummary
                  },
                  {
                    path: 'detail',
                    name: 'ticket3-agent-performance-detail',
                    component: Ticket3AgentPerformanceDetail
                  },
                  {
                    path: '',
                    redirect: 'detail'
                  }
                ]
              },
              {
                path: 'manage',
                name: 'ticket3-admin-management',
                component: Ticket3AgentManage
              }
            ]
          }
        ]
      },
      {
        path: 'survey',
        name: 'survey',
        component: LayoutSurvey,
        children: [
          {
            path: '',
            component: Survey
          }
        ],
        beforeEnter: guardRoute
      },
      {
        path: 'tigerpoly/members',
        name: 'tigerpoly-members',
        component: TigerpolyMember,
        beforeEnter: guardRoute,
        meta: {
          title: 'Members'
        }
      },
      {
        path: 'tigerpoly/reporting',
        name: 'tigerpoly-reporting',
        component: TigerpolyReporting,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reporting'
        }
      },
      {
        path: 'check-in-check-out',
        name: 'check-in-check-out',
        component: CheckInCheckOut,
        beforeEnter: guardRoute,
        meta: {
          title: 'Check in - Check out'
        }
      },
      {
        path: 'superrich/branches',
        name: 'superrich-branches',
        component: SuperrichBranch,
        beforeEnter: guardRoute,
        meta: {
          title: 'Branches management'
        }
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'EGG DIGITAL'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched
  //   .slice()
  //   .reverse()
  //   .find((r) => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (to.name == 'dashboard' && to.query && to.query.tab == 'ceemeagain') {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { tab: 'ceemeagain' }
      })
      return
    }
  }

  let query = { utm_source: to.query.utm_source }
  if (!query.redirect) {
    query.redirect = to.fullPath
  }

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function () {
            // checkTokenStatus(next)
            next()
          },
          function (error) {
            console.error(error)
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function () {
            // checkTokenStatus(next)
            next()
          },
          function (error) {
            console.error(error)
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardRoutePageToken(to, from, next) {
  const query = { ...to.query }
  try {
    // const mockjwt = jsonwebtoken.sign(
    //   {
    //     pageToken:
    //       'Nzc5MzBlOWRiYWQ3ODc1MDRhY2FmMWViMDFiODY5MjYwYWRhM2RmNDFkYTEzZTlmNjY1M2Y5YzIyZTQzMzE3Yw=='
    //   },
    //   'zwiz-plugin'
    // )
    // console.log({ mockjwt })
    // https://localhost:3000/th/tcp/plugin/broadcast?data=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYWdlVG9rZW4iOiJOemM1TXpCbE9XUmlZV1EzT0RjMU1EUmhZMkZtTVdWaU1ERmlPRFk1TWpZd1lXUmhNMlJtTkRGa1lURXpaVGxtTmpZMU0yWTVZekl5WlRRek16RTNZdz09IiwiaWF0IjoxNzE0MzczNDIzfQ.-isQ-xb8iSs9vpOY3a7BN3zemqOmxopm8TGEdSUbqPU
    store.dispatch('loading')
    const jwt = query.data
    const jwtData = jsonwebtoken.verify(jwt, 'zwiz-plugin')
    const { pageToken } = jwtData
    if (pageToken) {
      store.dispatch('updatePageToken', pageToken)
      store.dispatch('loadSetting')
    } else {
      throw new Error('pageToken not found')
    }
  } catch (error) {
    console.error(error)
    next({
      path: `/${store.getters.currentLang}/plugin/unauthorized`
    })
  } finally {
    store.dispatch('clear_loading')
    to.query.data && delete to.query.data
    next()
  }
}

function guardPartnerRoute(to, from, next) {
  let query = { utm_source: to.query.utm_source }
  if (!query.redirect) {
    query.redirect = to.fullPath
  }
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/nigol',
      query: query
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: query
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js